import { render, staticRenderFns } from "./BaseInputDate.vue?vue&type=template&id=14545859&scoped=true&"
import script from "./BaseInputDate.vue?vue&type=script&lang=ts&"
export * from "./BaseInputDate.vue?vue&type=script&lang=ts&"
import style0 from "./BaseInputDate.vue?vue&type=style&index=0&id=14545859&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14545859",
  null
  
)

export default component.exports